export default __webpack_public_path__ + "static/media/baby4 10.17 1.7503a366.png";